import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import {
    dStoresClearFiltersAC,
    dStoresSetFiltersAC,
    dStoresSetDataSagaAC,
    dStoresSetDetailItemAC,
    dStoresSetPageNumberAC, dStoresSetItemsForPageAC
} from 'model/dashboardStores/dStoresActionCreators'
import { IdStoresState, typeStoreFilters } from 'model/dashboardStores/dStoresReducer'
import { ViewDataStores } from './ViewComponent';
import { useInputChange } from 'hooks/useInputChange';
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";


// Type
export type typeDataStores = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}
export type typeDataStoresRowActions = { id?: string, title: JSX.Element, disableSwitcher?: boolean, action: (id: string) => void }[]
export type typeDataStoresBulkActions = { title: JSX.Element, action: () => void }[]


// Component
export const DataStores: React.FC<typeDataStores> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // DateFilter
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dStores: IdStoresState }) => state.dStores.filters)

    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dStores: IdStoresState }) => state.dStores.pagination),
        onGoToPage: (id) => dispatch(dStoresSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dStoresSetItemsForPageAC(itemsPerPage))
    }


    // Did mount & Did unmount
    useEffect(() => {
        return () => {
            dispatch(dStoresClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dStoresSetDataSagaAC(filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!,
        }, false));

        // eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ]);


    // Popup details
    const [ openPopupDetails, setOpenPopupDetails ] = useState(false)

    // Popup edit
    const [ openPopupEdit, setOpenPopupEdit ] = useState(false)

    // Search panel
    const searchName = useSelector((state: { dStores: IdStoresState }) => state.dStores.filters.name)
    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchName || '')
    const onClearSearch = () => {
        dispatch(dStoresSetFiltersAC({ name: null, deleted: false }))
        setSearchValue('')
    }
    const onEnterSearch = () => {
        const filters: typeStoreFilters = {
            name: searchValue.trim(),
        }
        dispatch(dStoresSetFiltersAC(filters))
    }

    // Current item
    const currentItem = useSelector((state: { dStores: IdStoresState }) => state.dStores.detailItem)


    // Item actions
    const rowsActions: typeDataStoresRowActions = [

        {
            title: <Trans>Edit</Trans>,
            disableSwitcher: true,
            action: (id: string) => {
                dispatch(dStoresSetDetailItemAC(id))
                setOpenPopupEdit(true)
            }
        },
    ]


    return (
        <ViewDataStores
            variant={ variant }
            setSidebarOpen={ setSidebarOpen }
            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }
            openPopupDetails={ openPopupDetails }
            setOpenPopupDetails={ setOpenPopupDetails }
            openPopupEdit={ openPopupEdit }
            setOpenPopupEdit={ setOpenPopupEdit }
            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onEnterSearch={ onEnterSearch }
            onClearSearch={ onClearSearch }
            rowsActions={ rowsActions }
            currentItem={ currentItem }
            pagination={ pagination }
        />

    )
}
